import React from "react";
import AllSubjectTopics from "../../topics/AllSubjectTopics";


function FormulaChemTopics() {
  return (
    <>

      <AllSubjectTopics  subject="chemistry" type="formula" />

    </>
  );
}

export default FormulaChemTopics;